import React from 'react';

const ArrowDown = () => (
  <span className="d-inline-block ml-2" style={{ transform: 'rotate(90deg)' }}>
    &rarr;
  </span>
);

export default ArrowDown;
